import { render, staticRenderFns } from "./TabNavigation.vue?vue&type=template&id=fc6fc616&scoped=true&"
import script from "./TabNavigation.vue?vue&type=script&lang=js&"
export * from "./TabNavigation.vue?vue&type=script&lang=js&"
import style0 from "./TabNavigation.vue?vue&type=style&index=0&id=fc6fc616&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc6fc616",
  null
  
)

export default component.exports